/* eslint-disable no-debugger */
<template>
  <gc-main-layout
    :title="title"
    :isXSmall="isXSmall"
    :isLarge="isLarge"
    :selectedIndex="selectedIndex"
    :baseView="baseView"
    :key="pageKey"
    :backButtonEnable="true"
    :backButtonFunction="backButtonFunction"
    :formsConfig="formsConfig"
    :hot-key-grid-tab-index="1"
    :hot-key-expand="expandGrid"
  >
    <template #headerContent>
      <GcHeaderContentDynamic
        title="Sales Order"
        :baseView="baseView"
        :primaryLabel="model.Name"
        :secondaryLabel="model.CustomerName"
      />
    </template>

    <DxToolbar class="view-toolbar despatch-order-toolbar">
      <DxItem
        widget="dxForm"
        location="before"
        :options="{
          formData: this.model,
          items: this.toolbarFormItems,
          validationGroup: 'toolbarForm',
          labelLocation: 'left',
          readOnly: true,
        }"
        locate-in-menu="auto"
      ></DxItem>

      <DxItem
        widget="dxForm"
        location="after"
        :options="{
          formData: model,
          items: toolbarActiveItems,
          validationGroup: 'toolbarForm-2',
          labelLocation: 'left',
        }"
        locate-in-menu="auto"
      ></DxItem>
      <DxItem
        :options="toolbar.audit"
        location="after"
        locate-in-menu="auto"
        widget="dxButton"
        v-if="baseView.mode == 'review'"
      />

      <DxItem
        :options="toolbar.notes"
        location="after"
        locate-in-menu="auto"
        widget="dxButton"
      />
      <DxItem
        :options="toolbar.edit"
        location="after"
        locate-in-menu="auto"
        widget="dxButton"
        v-if="baseView.mode == 'review'"
        :visible.sync="isEditVisible"
      />
      <DxItem
        :options="toolbar.save"
        location="after"
        locate-in-menu="auto"
        widget="dxButton"
        v-if="baseView.mode != 'review'"
        ref="save"
      />
    </DxToolbar>

    <div
      v-show="!gridExpanded"
      class="view-card responsive-paddings despatch-order-form"
    >
      <form v-if="loadingCompleted">
        <DxForm
          :ref="'despatch-form'"
          :form-data.sync="model"
          :read-only="false"
          :show-colon-after-label="false"
          :show-required-mark="false"
          :show-validation-summary="false"
          :validation-group="formsConfig.validationGroup"
          :label-location="formsConfig.labelPosition"
          :customizeItem="customizeItem"
          :items="headerFormItems"
          @content-ready="onContentReady"
        >
          <!-- SelectBox Template  -->
          <template #deliveryAddressTemplate="{ data }">
            <div class="custom-auto-complete">
              <span class="auto-complete-primary">{{ data.CompanyName }}</span>
              <br />
              <span class="auto-complete-secondary no-padding">
                {{ data.PhysicalAddressStreetLine1 }}
                <br />
                {{ data.PhysicalAddressStreetLine2 }}
                <br />
                {{ data.PhysicalAddressSuburb }}
                {{ data.PhysicalAddressState }}
                {{ data.PhysicalAddressPostcode }}
              </span>
            </div>
          </template>
          <template #editAddressTemplate>
            <div class="edit-address-btn">
              <span @click="editDeliveryAddress">
                <a>
                  {{ baseView.mode == "review" ? "View" : "Edit" }}
                </a>
              </span>
            </div>
          </template>
        </DxForm>
      </form>
    </div>

    <div v-if="loadingCompleted">
      <!-- <pre>
        {{ dispatchDataSourceConfig }}
      </pre>-->
      <dx-data-grid
        :data-source="dispatchDataSourceConfig"
        :ref="'despatch-grid'"
        :height="
          !gridExpanded
            ? gridHeight - (formHeight + toolbarHeight)
            : gridHeight - toolbarHeight
        "
        @toolbar-preparing="onToolbarPreparingDespatchOrder($event)"
        @cell-prepared="onCellPrepared"
        :columns="columns"
        @editing-start="onEditingStart"
        key-expr="LineNo"
        @content-ready="addGridNoResults($event)"
      >
        <DxEditing :allow-updating="true" mode="cell" />

        <template #cellTemplate="{ data }">
          <img
            :src="
              baseURL +
                '/api/GETMedia/ProductPrimaryImage?' +
                data.data.ItemCode
            "
          />
        </template>

        <template #primaryImageTemplate="{ data }">
          <div>
            <GcGridProductImage
              :ItemCode="data.data.ItemCode"
              :HasPrimaryImage="data.data.HasPrimaryImage"
              :Description="data.data.ItemDescription"
            />
          </div>
        </template>

        <template #qtyEditTemplate="{ data }">
          <div>
            <div>
              <DxNumberBox
                :value="data.value"
                @value-changed="salesUMPickedQtyChanged($event, data)"
                :disabled="data.data.Product.IsBatchProduct !== 'No'"
                :format="data.column.format"
                class="gc-grid-number-box-editor"
                :min="-99999999"
                :max="99999999"
              />
            </div>
          </div>
        </template>

        <template #completedEditTemplate="{ data }">
          <div>
            <div>
              <DxCheckBox
                :value="data.value"
                @value-changed="completedStatusChanged($event, data)"
                :read-only="
                  data.data.SalesUMPickedQty >= data.data.SalesUMBackorderQty
                "
              />
            </div>
          </div>
        </template>

        <DxMasterDetail :enabled="true" template="masterDetailTemplate" />
        <template #masterDetailTemplate="{ data: lineitem }">
          <GcBatchDespatchOrderDetails
            :template-data="lineitem"
            :parent-model="model"
            @batch-added="handleBatchAdded"
            :validationErrors="validationErrors"
          />
        </template>
        <template #menu-cell-template="{ data }">
          <DxDropDownButton
            :items="[
              {
                menuText: 'Item Price Update',
                data: data,
                visible: ItemPriceVisible,
              },
            ]"
            keyExpr="menuText"
            displayExpr="menuText"
            :drop-down-options="{ width: 250 }"
            class="gc-dropdown-icon-button"
            :id="data.data.Code"
            icon="overflow"
            styling-mode="text"
            :show-arrow-icon="false"
            :onItemClick="onItemClick"
            :disabled="!ItemPriceVisible"
          />
        </template>
      </dx-data-grid>
    </div>

    <DxPopup
      :visible.sync="commentsPopupVisible"
      :drag-enabled="false"
      :hide-on-outside-click="true"
      :show-title="true"
      title="Sales Order Comments"
      :width="550"
      :height="350"
      :showCloseButton="false"
    >
      <form>
        <DxForm
          :ref="'comments-form'"
          :customizeItem="customizeItem"
          :form-data.sync="model"
          :items="commentItems"
        ></DxForm>
      </form>

      <div class="footer">
        <DxButton
          text="Back"
          type="default"
          styling-mode="contained"
          @click="popUpBackButtonClick"
        />
      </div>
    </DxPopup>

    <gc-item-price-update
      v-if="visibleItemPriceUpdate"
      :setVisible="visibleItemPriceUpdate"
      :callBack="popUpCallBack"
      :itemPriceUpdateData="itemPriceUpdateData"
      :branchCode="model.BranchCode"
      :baseView="baseView"
    ></gc-item-price-update>

    <gc-edit-delivery-address
      :setVisible="visibleEditDeliveryAddress"
      :formModel="model"
      :CustomerCode="model.CustomerCode"
      :callBack="deliveryAddressCallBack"
    >
    </gc-edit-delivery-address>

    <template #footer>
      <div class="gc-grid-footer">
        <div class="gc-grid-footer-left">
          <div class="gc-grid-footer-item">
            <label class="gc-footer-label">Total Picked</label>
            <!-- <span class="gc-footer-amount">
              {{ totalPickedQty | number("0,0.00") }} /
              {{ totalBackOrderQty | number("0,0.00") }}
            </span> -->

            <GcFooterValue
              :value="totalPickedQty"
              :format="'Decimal-4-2'"
              :length="4"
            />
            <span class="seperator">/</span>

            <GcFooterValue
              :value="totalBackOrderQty"
              :format="'Decimal-4-2'"
              :length="4"
            />
          </div>
        </div>
      </div>
    </template>
  </gc-main-layout>
</template>

<script>
import BaseViewMixin from "../../v1/_mixins/base.view";
import { DespatchOrderService } from "../../_services/api/sales/despatch-order.service";
import { mapGetters } from "vuex";
import { CustomerDeliveryAddressService } from "../../_services/api/customers/customer-delivery-address.service";
import appConfig from "../../app-config";
import { DxMasterDetail } from "devextreme-vue/data-grid";
import SalesFormulas from "../../_helpers/formulas/sales-formulas";
import validationEngine from "devextreme/ui/validation_engine";
import { FeatureStorage } from "../../_services/storage";

var dispatchDataSource = DespatchOrderService.dataSourceConfig({
  expand: "Product",
  postProcess: (data) => {
    // eslint-disable-next-line no-console
    // this.$logger.debug("post process", data);
    data.forEach((element) => {
      if (element["Product"].IsBatchProduct == "No") {
        element["SalesUMPickedQty"] = element["SalesUMBackorderQty"];
        element["Completed"] = true;
      } else {
        element["SalesUMPickedQty"] = 0;
        element["PickingSlipProductBatches"] = [];
        element["Completed"] = false;
        if (element["IsBatchProduct"] != "No") {
          DespatchOrderService.getPickingSlipProductBatch(
            `ItemCode eq '${element["ItemCode"]}' and SalesOrderLineNo eq ${element["LineNo"]} and SalesOrderCode eq ${element["SalesOrderCode"]}`
          ).then((response) => {
            var totalQTY = 0;
            element["PickingSlipProductBatches"] = response.data.value;
            element["PickingSlipProductBatches"].forEach((batch) => {
              batch.Qty = batch.AllocatedQty;
              totalQTY = totalQTY + batch.AllocatedQty;
            });
            element["SalesUMPickedQty"] = totalQTY;

            if (totalQTY == element["SalesUMBackorderQty"])
              element["Completed"] = true;
            else element["Completed"] = false;

            element["BatchesDetails"] = element["PickingSlipProductBatches"];
          });
        } else {
          element["Completed"] = false;
        }
      }
    });
    return data;
  },
  // sort: [{ selector: "ItemCode", asc: true }],
  preventPagination: true,
});

var deliveryAddressDataSource = CustomerDeliveryAddressService.dataSourceConfig(
  "api/CustomerDeliveryAddress",
  {
    select: [
      "CompanyName",
      "PhysicalAddressStreetLine1",
      "PhysicalAddressStreetLine2",
      "PhysicalAddressSuburb",
      "PhysicalAddressState",
      "PhysicalAddressPostcode",
      "PhysicalAddressCountry",
    ],
  }
);

var batchDataSource = CustomerDeliveryAddressService.dataSourceConfig(
  "api/ConsumeProductBatch",
  {
    select: [
      "BatchNo",
      "SupplierCode",
      "SupplierName",
      "UseByDate",
      "AvailableQty",
    ],
  }
);

export default {
  props: {},
  mixins: [BaseViewMixin],
  components: {
    DxMasterDetail,
  },
  watch: {
    $route: {
      immediate: true,
      handler: "handleTabRouteChange",
    },
  },
  async created() {
    this.loadingCompleted = false;
    this.showLoading(true);
    this.model.SalesOrderCode = this.baseView.id;
    this.model.Name = `Sales Order # ${this.model.SalesOrderCode}`;

    // let that = this;

    let that = this;

    if (this.baseView.mode !== "create") {
      await DespatchOrderService.getDespatchOrderCode(this.baseView.id).then(
        (response) => {
          // this.$logger.debug("*************************** response", response);
          this.model.CustomerName = response.data.value[0].Customer.Name;
          that.refreshView();
          this.model.CustomerCode = response.data.value[0].CustomerCode;
          this.model.DeliveryAddressCompanyName =
            response.data.value[0].DeliveryAddressCompanyName;
          this.model.DateIn = new Date();
          this.model.BranchName = response.data.value[0].Branch.Description;
          this.model.BranchCode = response.data.value[0].BranchCode;
          this.model.DivisionName = response.data.value[0].Division.Description;
          this.model.SalesRepresentativeName =
            response.data.value[0].SalesRepresentative.FirstName +
            " " +
            response.data.value[0].SalesRepresentative.Surname;
          this.model.SalesOrderType =
            response.data.value[0].SalesOrderType.Description;
          this.model.OrderNo = response.data.value[0].OrderNo;
          this.model.Currency = response.data.value[0].Currency;
          this.model.RequiredByDate = response.data.value[0].RequiredByDate;
          this.model.ShipDate = response.data.value[0].ShipDate;
          this.model.ConNote = response.data.value[0].ConsignmentNo;

          this.model.DeliveryAddressStreetLine1 =
            response.data.value[0].DeliveryAddressStreetLine1;
          this.model.DeliveryAddressStreetLine2 =
            response.data.value[0].DeliveryAddressStreetLine2;
          this.model.DeliveryAddressSuburb =
            response.data.value[0].DeliveryAddressSuburb;
          this.model.DeliveryAddressState =
            response.data.value[0].DeliveryAddressState;
          this.model.DeliveryAddressPostcode =
            response.data.value[0].DeliveryAddressPostcode;
          this.model.DeliveryAddressCountry =
            response.data.value[0].DeliveryAddressCountry;

          this.model.UserComment1 = response.data.value[0].UserComment1;
          this.model.UserComment2 = response.data.value[0].UserComment2;
          this.model.UserComment3 = response.data.value[0].UserComment3;
          this.model.UserComment4 = response.data.value[0].UserComment4;
          this.model.UserComment5 = response.data.value[0].UserComment5;
          this.model.UserComment6 = response.data.value[0].UserComment6;
          this.model.UserComment7 = response.data.value[0].UserComment7;
          this.model.UserComment8 = response.data.value[0].UserComment8;
          this.model.UserComment9 = response.data.value[0].UserComment9;
          this.model.UserComment10 = response.data.value[0].UserComment10;
          this.model.UserComment11 = response.data.value[0].UserComment11;
          this.model.UserComment12 = response.data.value[0].UserComment12;
          this.model.UserComment13 = response.data.value[0].UserComment13;
          this.model.UserComment14 = response.data.value[0].UserComment14;
          this.model.UserComment15 = response.data.value[0].UserComment15;
          this.model.UserComment16 = response.data.value[0].UserComment16;
          this.model.UserComment17 = response.data.value[0].UserComment17;
          this.model.UserComment18 = response.data.value[0].UserComment18;
          this.model.UserComment19 = response.data.value[0].UserComment19;
          this.model.UserComment20 = response.data.value[0].UserComment20;
          this.model.DateChanged = response.data.value[0].DateChanged;
          this.model.DateCreated = response.data.value[0].DateCreated;
          this.model.ChangedBy = response.data.value[0].ChangedBy;
          this.model.CreatedBy = response.data.value[0].CreatedBy;
          for (let i = 1; i <= 20; i++) {
            let option = [];
            let label = "CommentLabel" + i;
            let required = "CommentRequired" + i;
            let labelData = response.data.value[0].SalesOrderType[label];
            let labelRequired = response.data.value[0].SalesOrderType[required];
            if (labelData) {
              option.push("UserComment" + i);
              option.push(labelData);
              option.push(labelRequired);
              this.model.commentOptions.push(option);
            }
          }
          // this.$logger.debug("Comments", this.model.commentOptions);
          this.generateFormData();

          // that.refreshView();

          deliveryAddressDataSource.filter([
            "CustomerCode",
            "=",
            this.model.CustomerCode,
          ]);
          deliveryAddressDataSource.load();

          this.showLoading(false);
          this.loadingCompleted = true;
        }
      );
    } else {
      this.model.DateIn = new Date();
      this.showLoading(false);
      this.loadingCompleted = true;
    }

    dispatchDataSource.filter([
      ["SalesOrderCode", "=", parseInt(this.baseView.id)],
      "and",
      [["Status", "=", "A"], "or", ["Status", "=", "I"]],
    ]);

    dispatchDataSource.load().then(() => {
      this.dispatchDataSourceConfig = dispatchDataSource.items();
      // this.$logger.debug(this.dispatchDataSourceConfig, "ds data");
    });
  },
  data() {
    return {
      formHeight: 0,
      toolbarHeight: 0,
      gridExpanded: false,
      visibleEditDeliveryAddress: false,
      dispatchDataSourceConfig: [],
      masterDetailDataSource: [],
      batchOptions: batchDataSource,
      baseURL: appConfig.VUE_APP_ROOT_API,
      isEditVisible: true,
      commentsPopupVisible: false,
      // id: Number(this.$route.params.id.split("/")[0]),
      model: {
        Customer: "",
        Name: "",
        SalesOrderCode: "",
        CustomerCode: "",
        DateIn: null,
        ProcessInvoice: true,
        PartDeliver: false,
        BackOrder: false,
        BranchCode: "",
        BranchName: "",
        DivisionName: "",
        SalesRepresentativeName: "",
        SalesOrderType: "",
        OrderNo: "",
        Currency: "",
        RequiredByDate: "",
        ShipDate: "",
        ConNote: "",
        Firm: "",
        DeliveryAddressCompanyName: undefined,
        DeliveryAddressStreetLine1: "",
        DeliveryAddressStreetLine2: "",
        DeliveryAddressSuburb: "",
        DeliveryAddressState: "",
        DeliveryAddressPostcode: "",
        DeliveryAddressCountry: "",
        UserComment1: "",
        UserComment2: "",
        UserComment3: "",
        UserComment4: "",
        UserComment5: "",
        UserComment6: "",
        UserComment7: "",
        UserComment8: "",
        UserComment9: "",
        UserComment10: "",
        UserComment11: "",
        UserComment12: "",
        UserComment13: "",
        UserComment14: "",
        UserComment15: "",
        UserComment16: "",
        UserComment17: "",
        UserComment18: "",
        UserComment19: "",
        UserComment20: "",
        commentOptions: [],
        DateChanged: "",
        DateCreated: "",
        ChangedBy: "",
        CreatedBy: "",
      },
      toolbar: {
        edit: {
          icon: "edit",
          onClick: () => {
            this.$router.push({
              path: `/despatch-order/edit/${this.model.SalesOrderCode}`,
            });
          },
        },
        save: {
          icon: "floppy",
          stylingMode: "text",
          validationGroup: "formsData",
          onClick: async (e) => {
            this.$logger.trackEventButtonClickSave();
            this.saveOrder(e);
          },
        },

        notes: {
          icon: "file",
          stylingMode: "text",
          showArrowIcon: false,
          onClick: () => {
            this.commentsPopupVisible = true;
            this.$logger.trackEventOpenPopup("Despatch Order Comments");
          },
        },
        autoComplete: {
          dataField: "Name",
        },
        audit: {
          icon: "clock",
          onClick: () => {
            this.displayAuditPopup(
              this.model.CreatedBy,
              this.model.DateCreated,
              this.model.ChangedBy,
              this.model.DateChanged
            );
          },
        },
      },
      items: [],

      commentItems: [
        {
          itemType: "group",
          caption: "",
          items: [],
        },
      ],
      visibleItemPriceUpdate: false,
      itemPriceUpdateData: null,
    };
  },
  computed: {
    columns() {
      return this.parseGridColumns("transaction-editable", [
        {
          gcLabel: "Item",
          gcType: "String",
          gcSubType: "PrimaryRecord",
          dataField: "ItemDescription",
          allowEditing: false,
          cellTemplate: "primaryImageTemplate",
        },
        {
          gcLabel: "Code",
          dataField: "ItemCode",
          width: 120,
          gcType: "String",
          gcSubType: "HiddenCode",
        },
        {
          gcLabel: "Description",
          dataField: "ItemDescription",
          width: 120,
          gcType: "String",
          gcSubType: "HiddenDescription",
        },
        {
          gcLabel: "Line No",
          dataField: "LineNo",
          gcType: "String",
          width: 100,
          visible: false,
        },
        {
          gcLabel: "UM",
          dataField: "SalesUM",
          gcType: "String",
          width: 100,
        },

        {
          gcLabel: "Price",
          dataField: "SalesUMNetFXPrice",
          gcType: "Decimal-6-2",
          allowFiltering: false,
        },

        {
          gcLabel: "GP",
          dataField: "SalesUMStandardCost",
          gcType: "Decimal-3-2P",
          allowFiltering: false,
          calculateCellValue: this.calculateCellValue,
        },

        {
          gcLabel: "Outstanding",
          dataField: "SalesUMBackorderQty",
          gcType: "Decimal-6-2",
          allowFiltering: false,
        },

        {
          gcLabel: "Despatch",
          dataField: "SalesUMPickedQty",
          editCellTemplate: "qtyEditTemplate",
          gcType: "Decimal-6-2",
          showEditorAlways: true,
          allowFiltering: false,
        },

        {
          gcLabel: "Complete",
          gcType: "Boolean",
          editCellTemplate: "completedEditTemplate",
          gcSubType: "EditableCheckBox",
          dataField: "Completed",
          showEditorAlways: true,
          allowFiltering: false,
        },
        {
          gcLabel: "",
          gcType: "String",
          gcSubType: "IconButton",
          cellTemplate: "menu-cell-template",
        },
      ]);
    },
    totalBackOrderQty() {
      let total = 0;
      this.dispatchDataSourceConfig.forEach((el) => {
        total += Number(el.SalesUMBackorderQty);
      });
      return total;
    },
    totalPickedQty() {
      let total = 0;
      this.dispatchDataSourceConfig.forEach((el) => {
        total += Number(el.SalesUMPickedQty);
      });
      return total;
    },
    toolbarFormItems() {
      return this.parseFormColumns([
        {
          dataField: "CustomerName",
          gcLabel: "Customer",
          gcType: "String",
          editorOptions: {
            tabIndex: -1,
            placeholder: "Customer Name",
          },
          required: true,
          labelVisible: false,
          editorType: "dxTextBox",
        },
      ]);
    },
    toolbarActiveItems() {
      return this.parseFormColumns([
        {
          dataField: "ProcessInvoice",
          gcType: "Boolean",
          gcLabel: "Process Invoice",
        },
      ]);
    },
    masterDetailEnabled() {
      return true;
    },
    ...mapGetters({ applicationMode: "profile/applicationMode" }),
    headerFormItems() {
      let items = [
        {
          itemType: "group",
          caption: "",
          colCount: 3,
          items: [
            {
              itemType: "group",
              caption: "",
              items: this.parseFormColumns([
                {
                  dataField: "DateIn",
                  gcLabel: "Date In",
                  gcType: "Date",
                  required: true,
                },
                {
                  dataField: "RequiredByDate",
                  gcLabel: "Reqd Date",
                  gcType: "Date",
                  editorOptions: {
                    readOnly: true,
                    tabIndex: -1,
                  },
                },
                {
                  dataField: "ShipDate",
                  gcLabel: "Ship Date",
                  gcType: "Date",
                  required: true,
                  editorOptions: {
                    readOnly: true,
                    tabIndex: -1,
                  },
                },
                {
                  dataField: "OrderNo",
                  gcLabel: "Cust PO",
                  gcType: "String",
                  editorOptions: {
                    readOnly: true,
                    tabIndex: -1,
                  },
                  editorType: "dxTextBox",
                },
              ]),
            },
            {
              itemType: "group",
              caption: "",
              items: this.parseFormColumns([
                {
                  dataField: "DeliveryAddressCompanyName",
                  gcLabel: "Deliver To",
                  gcType: "String",
                  editorType: "dxSelectBox",
                  editorOptions: {
                    dataSource: deliveryAddressDataSource,
                    valueExpr: "CompanyName",
                    displayExpr: "CompanyName",
                    searchExpr: ["CustomerCode", "CompanyName"],
                    searchMode: "contains",
                    showClearButton: true,
                    itemTemplate: "deliveryAddressTemplate",
                    searchEnabled: true,
                    onItemClick: this.changeAddressDetails,
                    acceptCustomValue: true,
                    onCustomItemCreating: this.customItemCreating,
                  },
                  validationRules: [
                    {
                      type: "required",
                      message: "Delivery address is required",
                    },
                  ],
                },
                {
                  dataField: "",
                  template: "editAddressTemplate",
                  gcType: "Button",
                },
                {
                  dataField: "ConNote",
                  gcLabel: "Con Note",
                  gcType: "String",
                  visible: this.baseView.mode != "create",
                  editorType: "dxTextBox",
                },

                {
                  dataField: "Currency",
                  gcLabel: "Currency",
                  gcType: "String",
                  editorOptions: {
                    readOnly: true,
                    tabIndex: -1,
                  },
                  editorType: "dxTextBox",
                },
              ]),
            },
            {
              itemType: "group",
              caption: "",
              items: this.parseFormColumns([
                {
                  dataField: "BranchName",
                  gcLabel: "Branch",
                  gcType: "String",
                  editorOptions: {
                    readOnly: true,
                    tabIndex: -1,
                  },
                  editorType: "dxTextBox",
                },
                {
                  dataField: "DivisionName",
                  gcLabel: "Division",
                  gcType: "String",
                  editorOptions: {
                    readOnly: true,
                    tabIndex: -1,
                  },
                  editorType: "dxTextBox",
                },
                {
                  dataField: "SalesOrderType",
                  gcLabel: "SO Type",
                  gcType: "String",
                  editorOptions: {
                    readOnly: true,
                    tabIndex: -1,
                  },
                  editorType: "dxTextBox",
                },
                {
                  dataField: "SalesRepresentativeName",
                  gcLabel: "Sales Rep",
                  gcType: "String",
                  editorOptions: {
                    readOnly: true,
                    tabIndex: -1,
                  },
                  editorType: "dxTextBox",
                },
              ]),
            },
          ],
        },
      ];

      return items;
    },
    customerCodeInstance() {
      return this.$refs["customerCode"];
    },
    dataSourceConfig() {
      return DespatchOrderService.dataSourceConfig({
        expand: "Product",
        filter: [
          ["SalesOrderCode", "=", parseInt(this.baseView.id)],
          "and",
          [["Status", "=", "A"], "or", ["Status", "=", "I"]],
        ],
      });
    },
    ItemPriceVisible() {
      return this.hasItemPriceUpdateAccess && this.baseView.mode != "review";
    },
    hasItemPriceUpdateAccess() {
      return FeatureStorage.checkPermission(
        "ItemPriceUpdate",
        this.baseView.mode
      );
    },
  },
  methods: {
    validationErrors(errors) {
      this.displayValidationSummary(errors);
    },
    expandGrid() {
      this.gridExpanded = !this.gridExpanded;
      this.$refs["despatch-grid"].instance.repaint(true);
    },
    onToolbarPreparingDespatchOrder(e) {
      var toolbarItems = e.toolbarOptions.items;
      var searchPanel = toolbarItems.find((item) => {
        return item.name === "searchPanel";
      });
      var columnChooserButton = toolbarItems.find((item) => {
        return item.name === "columnChooserButton";
      });

      let itemsToRemoveFromToolBar = [
        "searchPanel",
        "revertButton",
        "saveButton",
        "columnChooserButton",
      ];

      e.toolbarOptions.items = toolbarItems.filter(
        (item) => !itemsToRemoveFromToolBar.includes(item.name)
      );

      searchPanel.location = "after";

      e.toolbarOptions.items.unshift(searchPanel, columnChooserButton, {
        location: "after",
        locateinmenu: "auto",
        widget: "dxButton",
        options: {
          validationGroup: "formsData",
          icon: this.gridExpanded ? "collapse" : "expand",
          onClick: this.expandGrid,
        },
      });
    },
    onContentReady() {
      if (document.getElementsByClassName("despatch-order-form").length != 0) {
        this.formHeight = document.getElementsByClassName(
          "despatch-order-form"
        )[0].clientHeight;
        this.toolbarHeight = document.getElementsByClassName(
          "despatch-order-toolbar"
        )[0].clientHeight;
      }
    },
    editDeliveryAddress() {
      this.visibleEditDeliveryAddress = !this.visibleEditDeliveryAddress;
    },
    deliveryAddressCallBack() {
      this.visibleEditDeliveryAddress = false;
    },
    mergeDespatchOrderRecords(prevRecords, newRecords) {
      prevRecords.forEach((pr) => {
        let rec = newRecords.find(
          (n) => n.ItemCode == pr.ItemCode && n.LineNo == pr.LineNo
        );
        rec.Completed = pr.Completed;
        rec.SalesUMPickedQty = pr.SalesUMPickedQty;
      });

      return newRecords;
    },
    popUpCallBack(updated) {
      this.visibleItemPriceUpdate = !this.visibleItemPriceUpdate;
      if (updated)
        dispatchDataSource.load().then(() => {
          this.dispatchDataSourceConfig = this.mergeDespatchOrderRecords(
            this.dispatchDataSourceConfig,
            dispatchDataSource.items()
          );
        });
    },
    onItemClick(e) {
      // this.$logger.debug("click :", e);
      this.itemPriceUpdateData = e.itemData.data.data;
      this.visibleItemPriceUpdate = !this.visibleItemPriceUpdate;
    },
    customizeLineCommentItem(item) {
      if (item.itemType == "simple") {
        item.editorOptions = item.editorOptions || {};
        if (item.dataField == "Comment") {
          item.editorOptions.readOnly = this.baseView.mode == "review";
        } else {
          item.editorOptions.disabled = this.baseView.mode == "review";
        }
      }
    },
    calculateCellValue(rowData) {
      // eslint-disable-next-line no-console
      // this.$logger.debug(rowData.SalesUMStandardCost, "rowData");
      return SalesFormulas.calculateGrossProfitPcnt(
        rowData.SalesUMStandardCost,
        rowData.SalesUMNetPrice
      );
    },
    // eslint-disable-next-line no-unused-vars
    handleBatchAdded(e) {
      // eslint-disable-next-line no-console
      // this.$logger.debug("handleBatchAdded", e);
    },

    salesUMPickedQtyChanged(e, cellInfo) {
      // cellInfo.setValue(e.value);
      cellInfo.data.SalesUMPickedQty = e.value;

      let backOrderValue = cellInfo.data.SalesUMBackorderQty;

      if (e.value >= backOrderValue) {
        cellInfo.data.Completed = true;
      } else {
        cellInfo.data.Completed = false;
      }
    },
    completedStatusChanged(e, cellInfo) {
      cellInfo.data.Completed = e.value;
    },
    onAddClickHandler() {
      let grid = this.$refs["batch-child-grid"].instance;
      grid.addRow();
    },

    // eslint-disable-next-line no-unused-vars
    onEditingStart(e) {
      // this.$logger.debug("on editing start", e);
    },

    onCellPrepared(e) {
      // this.$logger.debug(e, "cell prepared");
      if (e.rowType === "data" && e.column.command === "expand") {
        if (e.data.Product.IsBatchProduct == "No") {
          e.cellElement.classList.remove("dx-datagrid-expand");
          e.cellElement.childNodes[0].classList.remove(
            "dx-datagrid-group-closed"
          );
        }
      }

      if (e.rowType === "data" && e.column.dataField === "SalesUMPickedQty") {
        if (e.data.Product.IsBatchProduct !== "No") {
          e.cellElement.classList.remove("gc-editor-cell");
        }
      }
    },
    backButtonFunction() {
      this.$router.push({
        path: "/despatch-order",
      });
    },

    handleTabRouteChange() {
      if (this.baseView.modal == "edit") {
        this.customerCodeInstance.$options.propsData.options.value = this.model.CustomerCode;
        this.customerCodeInstance.repaint();
      }

      if (this.baseView.tab === "details") {
        this.selectedIndex = 1;
        // this.$logger.debug("route changes", this.baseView.mode);
      } else {
        this.selectedIndex = 0;
        this.$router.push({
          path: `/despatch-order/${this.baseView.mode}/${this.baseView.id}/header`,
        });
      }
    },
    generateFormData() {
      this.$logger.debug("Inside generate form data");
      this.model.commentOptions.forEach((el) => {
        let item = {
          dataField: el[0],
          label: { text: el[1] },
          editorType: "dxTextBox",
          validationRules: [],
        };
        if (el[2] == "Y") {
          item["validationRules"].push({
            type: "required",
            message: "Comment is required",
          });
        }
        this.$logger.debug("Item", item);
        this.commentItems[0].items.push(item);
        // this.$logger.debug("Inside generate form", this.commentItems[0].items);
      });
      let form = this.$refs["comments-form"].instance;
      // this.$logger.debug("form", form);
      form.repaint();
    },

    async saveOrder(e) {
      this.$logger.debug(e);
      // this.$logger.debug(this.dispatchDataSourceConfig, "dispatchDataSourceConfig");
      const result = await validationEngine.validateGroup("formsData");
      // eslint-disable-next-line no-console
      // this.$logger.debug("broken rules array", result.brokenRules);
      if (!result.isValid) {
        this.addErrorMessagesFromValidationResult(result);
        this.displayCustomValidationSummary();
        return;
      }
      let payload = {
        DateIn: this.model.DateIn.toSaveDate(),
        ProcessInvoice: this.model.ProcessInvoice ? "Y" : "N",
        PartDeliver: this.model.PartDeliver ? "Y" : "N",
        BackOrder: this.model.BackOrder ? "Y" : "N",
        DeliveryAddressCompanyName: this.model.DeliveryAddressCompanyName,
        DeliveryAddressCountry: this.model.DeliveryAddressCountry,
        DeliveryAddressPostcode: this.model.DeliveryAddressPostcode,
        DeliveryAddressState: this.model.DeliveryAddressState,
        DeliveryAddressStreetLine1: this.model.DeliveryAddressStreetLine1,
        DeliveryAddressStreetLine2: this.model.DeliveryAddressStreetLine2,
        DeliveryAddressSuburb: this.model.DeliveryAddressSuburb,
        ConsignmentNo: this.model.ConsignmentNo,
        SalesOrderCode: this.model.SalesOrderCode,
        UserComment1: this.model.UserComment1,
        UserComment10: this.model.UserComment10,
        UserComment11: this.model.UserComment11,
        UserComment12: this.model.UserComment12,
        UserComment13: this.model.UserComment13,
        UserComment14: this.model.UserComment14,
        UserComment15: this.model.UserComment15,
        UserComment16: this.model.UserComment16,
        UserComment17: this.model.UserComment17,
        UserComment18: this.model.UserComment18,
        UserComment19: this.model.UserComment19,
        UserComment2: this.model.UserComment2,
        UserComment20: this.model.UserComment20,
        UserComment3: this.model.UserComment3,
        UserComment4: this.model.UserComment4,
        UserComment5: this.model.UserComment5,
        UserComment6: this.model.UserComment6,
        UserComment7: this.model.UserComment7,
        UserComment8: this.model.UserComment8,
        UserComment9: this.model.UserComment9,
        PickingSlipDetails: [],
        ScreenName: "Order Despatch Console",
      };

      this.dispatchDataSourceConfig.forEach((el) => {
        let obj = {
          BatchStockTolerance: el.Product.BatchStockTolerance,
          Completed: el.Completed ? "Y" : "N",
          ItemCode: el.ItemCode,
          LineNo: el.LineNo,
          SalesUM: el.SalesUM,
          SalesUMConversion: el.SalesUMConversion,
          SalesUMInvoiceConversion: el.SalesUMConversion,
          SalesUMIsVariable: el.SalesUMIsVariable,
          SalesUMQuantityToPick: el.SalesUMPickedQty,
          StockUM: el.Product.UnitOfMeasureCode,
          StockUMQuantityToPick:
            el.SalesUMPickedQty *
            (el.SalesUMConversion == 0 ? 1 : el.SalesUMConversion),
          PickingSlipProductBatches: [],
        };

        if (el.PickingSlipProductBatches) {
          let validBatches = el.PickingSlipProductBatches.filter((b) => {
            return b.BatchNo !== "" && b.Qty > 0;
          });

          validBatches.forEach((i) => {
            let objBatch = {
              BatchNo: i.BatchNo,
              SalesUMInvoiceConversion: el.SalesUMConversion,
              SalesUMQuantityToPick: i.Qty,
              StockUMQuantityToPick:
                i.Qty * (el == 0 ? 1 : el.SalesUMConversion),
              SupplierCode: i.SupplierCode,
            };
            obj.PickingSlipProductBatches.push(objBatch);
          });
        } else {
          delete obj.PickingSlipProductBatches;
        }

        payload.PickingSlipDetails.push(obj);
      });

      this.showLoading(true);
      await DespatchOrderService.saveDespatchOrder(payload)
        .then((res) => {
          this.showLoading(false);

          this.$notify(
            `Sales Order ${this.model.SalesOrderCode} despatched successfully`,
            "success"
          );

          this.setIgnoreRouteChangeConfirmation();
          this.$router.push({
            path: `/despatch-order`,
          });

          this.$logger.debug("response", res);
        })
        .catch((error) => {
          this.displayServerError(error, "Despatch save failed");
        });
    },
    async updateOrder() {
      await DespatchOrderService.updateDespatchOrder(
        this.model,
        this.model.SalesOrderCode
      )
        // eslint-disable-next-line no-unused-vars
        .then((result) => {
          // this.$logger.debug(" **********************  result", result);
        })
        // eslint-disable-next-line no-unused-vars
        .catch((err) => {
          // this.$logger.debug(" **********************  err", err);
        });
    },
    popUpBackButtonClick() {
      this.commentsPopupVisible = false;
    },

    changeAddressDetails(e) {
      if (e.itemData) {
        this.model.DeliveryAddressStreetLine1 = e.itemData.PhysicalAddressStreetLine1;
        this.model.DeliveryAddressStreetLine2 = e.itemData.PhysicalAddressStreetLine2;
        this.model.DeliveryAddressSuburb = e.itemData.PhysicalAddressSuburb;
        this.model.DeliveryAddressState = e.itemData.PhysicalAddressState;
        this.model.DeliveryAddressPostcode = e.itemData.PhysicalAddressPostcode;
        this.model.DeliveryAddressCountry = e.itemData.PhysicalAddressCountry;
      }
      this.$logger.debug("ee ", this.model);
    },
    customItemCreating(data) {
      if (!data.text) {
        data.customItem = null;
        return;
      }

      const newItem = {
        CompanyName: data.text,
        PhysicalAddressCountry: "",
        PhysicalAddressPostcode: "",
        PhysicalAddressState: "",
        PhysicalAddressStreetLine1: "",
        PhysicalAddressStreetLine2: "",
        PhysicalAddressSuburb: "",
      };

      data.customItem = newItem;
    },
  },
};
</script>
